import { Box, Text, Grid, useToast, Image } from '@chakra-ui/react'
import { social_media_color } from '../../socal.js'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const SocialMediaColor = ({ setSide, side }) => {
    const [category, setCategory] = useState('hex')
    const navigate = useNavigate()
    const toast = useToast();

    const copyToClipboard = (ele) => {
        navigator.clipboard.writeText(ele);
        toast({ title: 'Color Copied', description: ele, status: 'success', duration: 3000, isClosable: true, position: 'top' })
    }

    return (
        <Box w={'90%'} m={'0.5cm auto 0.7cm auto'} >

            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} m={'0.5cm auto'}>
                <Box>{!side && <Box display={'flex'} alignItems={'center'} fontSize={['20px','25px']} fontWeight={'bold'} m={'0.5cm auto 0.5cm auto'}>
                    <Text ml={'10px'} cursor={'pointer'} onClick={() => setSide(!side)}>|||</Text>
                    <Text ml={'15px'} cursor={'pointer'} onClick={() => navigate('/')}>ArtKorner</Text>
                </Box>}
                </Box>
                <select onChange={(e) => setCategory(e.target.value)} style={{ width: '150px', fontSize: '14px', padding: '10px', border: '1px solid grey', borderRadius: '25px' }}>
                    <option value="hex">HEX</option>
                    <option value="rgb">RGB</option>
                    <option value="hsl">HSL</option>
                </select>
            </Box>

            <Grid templateColumns={['repeat(2, 1fr)','repeat(2, 1fr)','repeat(3, 1fr)', 'repeat(4, 1fr)']} gap={['10px','20px','30px']}>
                {social_media_color && social_media_color?.map((ele, index) => (
                    <Box key={index} onClick={() => copyToClipboard(ele[category])} display={'flex'} justifyContent={'center'} alignItems={'center'} bg={ele.hex} color={'white'} borderRadius={'10px'}>
                        <Box cursor={'pointer'} w={'100%'} h={'200px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <Box textAlign={'center'}>
                                <Image display={'block'} m={'auto'} w={'30%'} style={{ filter: 'invert(1)' }} src={ele.avatar} alt={ele.name} />
                                <Text fontSize={'14px'} mt={'5px'}>{ele.name}</Text>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Grid>
        </Box>
    )
}